/// <reference path="ReconciliationEntryState.ts" />

// A bank movement in the reconciliation list: its date, concept and reference, the amount and
// the state of its journal entry as a dot (red without entry, yellow while it is a draft, green
// once it is locked).
class BankMovementReconciliationCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private subConceptLabel:MUILabel = null;
    private amountLabel:MUILabel = null;
    private statusDot:MUIView = null;

    awakeFromHTML(){
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.subConceptLabel = MUIOutlet(this, "sub-concept-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.statusDot = MUIOutlet(this, "status-dot", "MUIView");
    }

    /// Marks the last movement of a bank account, which closes its card.
    set isLastInSection(value:boolean) {
        if (value) MUICoreLayerAddStyle(this.layer, "rec-last");
        else MUICoreLayerRemoveStyle(this.layer, "rec-last");
    }

    private _item:BankMovement = null;
    set item(item:BankMovement) {
        this._item = item;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let escape = ReconciliationEntryStateHelper.escape;

        this.dateLabel.text = item.date != null ? ad.dateFormatter.stringFromDate(item.date) : "";
        this.conceptLabel.text = escape(item.concept);
        this.amountLabel.text = ad.currencyFormatter.stringFromNumber(item.amount ?? 0);

        // the movement's reference, else what kind of movement it is
        let reference = [item.reference, item.reference1, item.reference2, item.documentNumber].find(r => r != null && r.trim().length > 0);
        let subConcept = reference ?? item.typeDescription;
        this.subConceptLabel.text = escape(subConcept);
        this.subConceptLabel.hidden = subConcept == null || subConcept.length == 0;

        ReconciliationEntryStateHelper.applyStateToDot(this.statusDot.layer as HTMLElement, ReconciliationEntryStateHelper.stateForItem(item));
    }
    get item():BankMovement { return this._item; }
}
